exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-mirror-dialog {\n  display: block;\n  width: 700px;\n}", ""]);

// exports
